module.exports = __webpack_public_path__ + "static/img/组 2425.4a347973.png";